export const WHITELABEL = {
    whiteLabels: ['tecban', 'ciabra', 'fundomultisupermercados', 'netmoney', 
                  'osinteligenciafinanceira', 'poenatela', 'viainvest', 'm7', 
                  'intrabank', 'iriom', 'biz2bank', 'amb', 'carbon', 
                  'somospremium', 'trial', 'mgpay', 'vuptcred', 'universo',
                  'somma', 'trial2', 'trial3'],
    partners: {
        1: 'Cashforce',
        2: 'Tecban',
        3: 'Ciabra',
        4: 'Fundo Multi Supermercados',
        5: 'Netmoney',
        6: 'O.S. Inteligência Financeira',
        7: 'Põe na tela',
        8: 'Via Invest',
        9: 'M7',
        10: 'Intrabank',
        11: 'Iriom',
        12: 'Biz2Bank',
        13: 'AMB',
        14: 'Carbon',
        15: 'Somos Premium',
        16: 'Trial',
        17: 'MGpay',
        18: 'Vupt Cred',
        19: 'Universo',
        20: 'Somma',
        21: 'Trial 2',
        22: 'Trial 3',
    },
    cashforce: {
        name: 'CASHFORCE',
        primaryColorName: 'blue',
        secundaryColorName: 'darkblue',
        primaryColorHex: {
            one: "#E7EBFF",
            two: "#CAD3FF",
            three: "#6D85FD",
            four: "#3D5DFC",
            five: "#0C34FB",
            six: "#0927BC",
        },
        secundaryColorHex: {
            one: "#CCD1DC",
            two: "#9AA4B9",
            three: "#677697",
            four: "#354974",
            five: "#021B51",
            six: "#02143D",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION
        },
        contact: {
            email: "atendimento@cashforce.com.br",
            tel: "5511941739617",
        },
        favicon: '/favicon.png',
        email: 'atendimento@cashforce.com.br',
    },
    tecban: {
        name: 'TECBAN',
        primaryColorName: 'pred',
        secundaryColorName: 'darkgrey',
        primaryColorHex: {
            one: "#FEF4F4",
            two: "#FA565B",
            three: "#FA565B",
            four: "#E3001B",
            five: "#B21728",
            six: "#B21728",
        },
        secundaryColorHex: {
            one: "#E8E8E8",
            two: "#B3B3B3",
            three: "#737373",
            four: "#272727",
            five: "#404040",
            six: "#333333",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_TECBAN,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_TECBAN,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_TECBAN
        },
        contact: {
            email: "atendimento@cashforce.com.br",
            tel: "5511941739617",
        },
        favicon: '/tecban-favicon.png',
        email: 'atendimento@cashforce.com.br',
    },
    ciabra: {
        name: 'CIABRA',
        primaryColorName: 'jungle-green-',
        secundaryColorName: 'jungle-yellow-',
        primaryColorHex: {
            one: "#EAF9F5",
            two: "#C0E9DF",
            three: "#7DCDBB",
            four: "#26AC8D",
            five: "#258D7A",
            six: "#25736B",
        },
        secundaryColorHex: {
            one: "#EAF9F5",
            two: "#C0E9DF",
            three: "#7DCDBB",
            four: "#26AC8D",
            five: "#258D7A",
            six: "#25736B",
            seven: "#141414",
        },
        ilustra: {
            primary: "#26AC8D",
            secundary: "#141414"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_CIABRA,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_CIABRA,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_CIABRA
        },
        favicon: '/ciabra-favicon.ico',
        email: 'atendimento@ciabra.com.br',
        contact: {
            email: "atendimento@ciabra.com.br",
            tel: "5511941739617"
        },
    },
    fundomultisupermercados: {
        name: 'FUNDO MULTI SUPERMERCADOS',
        primaryColorName: 'brr-blue-',
        secundaryColorName: 'brr-yellow-',
        primaryColorHex: {
            one: "#E8F1F6",
            two: "#B6CEDB",
            three: "#5D8499",
            four: "#34657F",
            five: "#2D4C64",
            six: "#2A4157",
        },
        secundaryColorHex: {
            one: "#F2EBDF",
            two: "#E5D7BF",
            three: "#CAAF80",
            four: "#BD9B60",
            five: "#978059",
            six: "#786A53",
            seven: "#141414",
        },
        ilustra: {
            primary: '#978059',
            secundary: "#2D4C64"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_FMS,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_FMS,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_FMS
        },
        favicon: '/fms-favicon.png',
        email: 'atendimento@fundomultisupermercados.com.br',
        contact: {
            email: "atendimentofornecedor@fundomultisupermercados.com.br",
            tel: "552138248876"
        },
    },
    netmoney: {
        name: 'NETMONEY',
        primaryColorName: 'aquamarine-',
        secundaryColorName: 'gold-',
        primaryColorHex: {
            one: "#ABCDCF",
            two: "#90C1C5",
            three: "#73B6BB",
            four: "#4DA7AF",
            five: "#439DA4",
            six: "#2C5E62",
        },
        secundaryColorHex: {
            one: "#FFE8AD",
            two: "#FFDF90",
            three: "#FFD467",
            four: "#FFCB00",
            five: "#DFB240",
            six: "#B99334",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_NETMONEY,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_NETMONEY,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_NETMONEY
        },
        contact: {
            email: "atendimento@netmoney.com.br",
            tel: "556434328550",
        },
        favicon: '/netmoney-favicon.png',
    },
    osinteligenciafinanceira: {
        name: 'OS INTELIGENCIA FINANCEIRA',
        primaryColorName: 'blue',
        secundaryColorName: 'darkblue',
        primaryColorHex: {
            one: "#E7EBFF",
            two: "#CAD3FF",
            three: "#6D85FD",
            four: "#3D5DFC",
            five: "#0C34FB",
            six: "#0927BC",
        },
        secundaryColorHex: {
            one: "#CCD1DC",
            two: "#9AA4B9",
            three: "#677697",
            four: "#354974",
            five: "#021B51",
            six: "#02143D",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_OS,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_OS,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_OS
        },
        contact: {
            email: "atendimento@cashforce.com.br",
            tel: "5511941739617",
        },
        favicon: '/favicon.png',
        email: 'atendimento@cashforce.com.br',
    },
    poenatela: {
        name: 'POE NA TELA',
        primaryColorName: 'blue',
        secundaryColorName: 'darkblue',
        primaryColorHex: {
            one: "#E7EBFF",
            two: "#CAD3FF",
            three: "#6D85FD",
            four: "#3D5DFC",
            five: "#0C34FB",
            six: "#0927BC",
        },
        secundaryColorHex: {
            one: "#CCD1DC",
            two: "#9AA4B9",
            three: "#677697",
            four: "#354974",
            five: "#021B51",
            six: "#02143D",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_PNT,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_PNT,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_PNT
        },
        contact: {
            email: "atendimento@cashforce.com.br",
            tel: "5511941739617",
        },
        favicon: '/favicon.png',
        email: 'atendimento@cashforce.com.br',
    },
    viainvest: {
        name: 'VIA INVEST',
        primaryColorName: 'navy-',
        secundaryColorName: 'tango-',
        primaryColorHex: {
            one: "#9A98C0",
            two: "#9A98C0",
            three: "#413E80",
            four: "#2E2C6C",
            five: "#1E1C58",
            six: "#1E1C58",
        },
        secundaryColorHex: {
            one: "#E58348",
            two: "#E58348",
            three: "#E58348",
            four: "#F37021",
            five: "#E56A20",
            six: "#E56A20",
        },
        ilustra: {
            primary: '#E56A20',
            secundary: "#1E1C58"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_VIAINVEST,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_VIAINVEST,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_VIAINVEST
        },
        contact: {
            email: "comercial@viainvest.com.br",
            tel: "551155552144",
        },
        favicon: '/viainvest-favicon.png',
        email: 'comercial@viainvest.com.br',
    },
    m7: {
        name: 'M7',
        primaryColorName: 'yankees-blue-',
        secundaryColorName: 'lime-',
        primaryColorHex: {
            one: "#6C7E9A",
            two: "#6C7E9A",
            three: "#3B4F6D",
            four: "#152743",
            five: "#101F36",
            six: "#101F36",
        },
        secundaryColorHex: {
            one: "#D8F680",
            two: "#D8F680",
            three: "#D8F680",
            four: "#C4E661",
            five: "#AAC659",
            six: "#AAC659",
        },
        ilustra: {
            primary: '#AAC659',
            secundary: "#101F36"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_M7,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_M7,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_M7
        },
        contact: {
            email: "operacoes@multisete.com",
            tel: "0800 591 0077",
        },
        favicon: '/m7-favicon.svg',
        email: 'operacoes@multisete.com',
    },
    intrabank: {
        name: 'INTRABANK',
        primaryColorName: 'midnight-blue-',
        secundaryColorName: 'middle-blue-',
        primaryColorHex: {
            one: "#417699",
            two: "#417699",
            three: "#1B5175",
            four: "#003960",
            five: "#002D4C",
            six: "#002D4C",
        },
        secundaryColorHex: {
            one: "#AEE1ED",
            two: "#AEE1ED",
            three: "#AEE1ED",
            four: "#75C9DC",
            five: "#53AEC3",
            six: "#53AEC3",
        },
        ilustra: {
            primary: '#53AEC3',
            secundary: "#002D4C"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_INTRABANK,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_INTRABANK,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_INTRABANK
        },
        contact: {
            email: "suporte@agenteintrabank.com.br",
            tel: "1146733300",
        },
        favicon: '/intrabank-favicon.png',
        email: 'suporte@agenteintrabank.com.br',
    },
    iriom: {
        name: 'IRIOM',
        primaryColorName: 'iriom-dark-',
        secundaryColorName: 'iriom-yellow-',
        primaryColorHex: {
            one: "#A2A2A2",
            two: "#A2A2A2",
            three: "#646464",
            four: "#191919",
            five: "#242424",
            six: "#242424",
        },
        secundaryColorHex: {
            one: "#FFD467",
            two: "#FFD467",
            three: "#FFD467",
            four: "#FFD600",
            five: "#DFB240",
            six: "#DFB240",
        },
        ilustra: {
            primary: '#DFB240',
            secundary: "#242424"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_IRIOM,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_IRIOM,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_IRIOM
        },
        contact: {
            email: 'operacoes@iriom.com.br',
            tel: '0800 591 1244',
        },
        favicon: '/iriom-favicon.png',
        email: 'operacoes@iriom.com.br',
    },
    biz2bank: {
        name: 'BIZ2BANK',
        primaryColorName: 'bee-dark-',
        secundaryColorName: 'bee-yellow-',
        primaryColorHex: {
            one: "#A2A2A2",
            two: "#A2A2A2",
            three: "#646464",
            four: "#000000",
            five: "#1A1A1A",
            six: "#1A1A1A",
        },
        secundaryColorHex: {
            one: "#FFD467",
            two: "#FFD467",
            three: "#FFD467",
            four: "#FFCF34",
            five: "#DFB240",
            six: "#DFB240",
        },
        ilustra: {
            primary: '#DFB240',
            secundary: "#1A1A1A"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_BIZ2BANK,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_BIZ2BANK,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_BIZ2BANK
        },
        contact: {
            email: 'contato@biz2bank.com.br',
            tel: "21990119722",
        },
        favicon: '/biz2bank-favicon.png',
        email: 'contato@biz2bank.com.br',
    },
    trial: {
        name: 'TRIAL',
        primaryColorName: 'blue',
        secundaryColorName: 'darkblue',
        primaryColorHex: {
            one: "#E7EBFF",
            two: "#CAD3FF",
            three: "#6D85FD",
            four: "#3D5DFC",
            five: "#0C34FB",
            six: "#0927BC",
        },
        secundaryColorHex: {
            one: "#CCD1DC",
            two: "#9AA4B9",
            three: "#677697",
            four: "#354974",
            five: "#021B51",
            six: "#02143D",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_TRIAL,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_TRIAL,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_TRIAL
        },
        contact: {
            email: "atendimento@vuptcred.com.br",
            tel: "48991232121",
        },
        favicon: '/favicon.png',
        email: 'atendimento@vuptcred.com.br',
    },
    trial2: {
        name: 'TRIAL 2',
        primaryColorName: 'blue',
        secundaryColorName: 'darkblue',
        primaryColorHex: {
            one: "#E7EBFF",
            two: "#CAD3FF",
            three: "#6D85FD",
            four: "#3D5DFC",
            five: "#0C34FB",
            six: "#0927BC",
        },
        secundaryColorHex: {
            one: "#CCD1DC",
            two: "#9AA4B9",
            three: "#677697",
            four: "#354974",
            five: "#021B51",
            six: "#02143D",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_TRIAL2,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_TRIAL2,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_TRIAL2
        },
        contact: {
            email: "atendimento@cashforce.com.br",
            tel: "5511941739617",
        },
        favicon: '/favicon.png',
        email: 'atendimento@cashforce.com.br',
    },
    trial3: {
        name: 'TRIAL 3',
        primaryColorName: 'blue',
        secundaryColorName: 'darkblue',
        primaryColorHex: {
            one: "#E7EBFF",
            two: "#CAD3FF",
            three: "#6D85FD",
            four: "#3D5DFC",
            five: "#0C34FB",
            six: "#0927BC",
        },
        secundaryColorHex: {
            one: "#CCD1DC",
            two: "#9AA4B9",
            three: "#677697",
            four: "#354974",
            five: "#021B51",
            six: "#02143D",
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_TRIAL3,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_TRIAL3,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_TRIAL3
        },
        contact: {
            email: "atendimento@cashforce.com.br",
            tel: "5511941739617",
        },
        favicon: '/favicon.png',
        email: 'atendimento@cashforce.com.br',
    },
    somospremium: {
        name: 'SOMOS PREMIUM',
        primaryColorName: 'premium-brown-',
        secundaryColorName: 'premium-yellow-',
        primaryColorHex: {
            one: "#C08D73",
            two: "#C08D73",
            three: "#8E5B42",
            four: "#6E4733",
            five: "#7D533E",
            six: "#7D533E",
        },
        secundaryColorHex: {
            one: "#FFD467",
            two: "#FFD467",
            three: "#FFD467",
            four: "#BD982E",
            five: "#DFB240",
            six: "#DFB240",
        },
        ilustra: {
            primary: '#DFB240',
            secundary: "#7D533E"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_SOMOSPREMIUM,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_SOMOSPREMIUM,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_SOMOSPREMIUM
        },
        contact: {
            email: 'suporte@somospremium.com.br',
            tel: '11 976880147',
        },
        favicon: '/somospremium-favicon.png',
        email: 'suporte@somospremium.com.br',
    },
    carbon: {
        name: 'CARBON',
        primaryColorName: 'carbon-primary-',
        secundaryColorName: 'carbon-secondary-',
        primaryColorHex: {
            one: "#9BDEDE",
            two: "#9BDEDE",
            three: "#65CCCC",
            four: "#47BAB9",
            five: "#40ABAA",
            six: "#40ABAA",
        },
        secundaryColorHex: {
            one: "#AEE1ED",
            two: "#AEE1ED",
            three: "#AEE1ED",
            four: "#2F2E2E",
            five: "#53AEC3",
            six: "#53AEC3",
        },
        ilustra: {
            primary: "#47BAB9",
            secundary: "#2F2E2E"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_CARBON,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_CARBON,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_CARBON
        },
        contact: {
            email: 'mesafornecedores@carboncapital.com.br',
            tel: '11 4003 8028',
        },
        favicon: '/carbon-favicon.png',
        email: 'mesafornecedores@carboncapital.com.br',
    },
    amb: {
        name: 'AMB',
        primaryColorName: 'amb-primary-',
        secundaryColorName: 'amb-secondary-',
        primaryColorHex: {
            one: "#A2A2A2",
            two: "#A2A2A2",
            three: "#464244",
            four: "#383436",
            five: "#242424",
            six: "#242424",
        },
        secundaryColorHex: {
            one: "#B31C36",
            two: "#B31C36",
            three: "#B31C36",
            four: "#B31C36",
            five: "#B31C36",
            six: "#B31C36",
        },
        ilustra: {
            primary: "#B31C36",
            secundary: "#383436"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_AMB,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_AMB,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_AMB
        },
        contact: {
            email: 'suporte@ambfidc.com.br',
            tel: '86 3025 1111',
        },
        favicon: '/amb-favicon.svg',
        email: 'suporte@ambfidc.com.br',
    },
    mgpay: {
        name: 'MGPAY',
        primaryColorName: 'mgpay-primary-',
        secundaryColorName: 'mgpay-secondary-',
        primaryColorHex: {
            one: "#676D99",
            two: "#676D99",
            three: "#363B64",
            four: "#1E2243",
            five: "#141837",
            six: "#141837",
        },
        secundaryColorHex: {
            one: "#C4AC6C",
            two: "#C4AC6C",
            three: "#C4AC6C",
            four: "#C4AC6C",
            five: "#C4AC6C",
            six: "#C4AC6C",
        },
        ilustra: {
            primary: "#C4AC6C",
            secundary: "#1E2243"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_MGPAY,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_MGPAY,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_MGPAY
        },
        contact: {
            email: 'contato@mgpayrecebíveis.com.br',
            tel: '11 2361 2122',
        },
        favicon: '/mgpay-favicon.svg',
        email: 'contato@mgpayrecebíveis.com.br',
    },
    universo: {
        name: 'UNIVERSO',
        primaryColorName: 'universo-primary-',
        secundaryColorName: 'universo-secondary-',
        primaryColorHex: {
            one: "#7B7B7B",
            two: "#7B7B7B",
            three: "#383838",
            four: "#191919",
            five: "#000000",
            six: "#000000",
        },
        secundaryColorHex: {
            one: "#FFC845",
            two: "#FFC845",
            three: "#FFC845",
            four: "#FFC845",
            five: "#FFC845",
            six: "#FFC845",
        },
        ilustra: {
            primary: "#FFC845",
            secundary: "#191919"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_UNIVERSO,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_UNIVERSO,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_UNIVERSO
        },
        contact: {
            email: 'comercial@financeirauniverso.com',
            tel: '85 99292 1462',
        },
        favicon: '/universo-favicon.svg',
        email: 'comercial@financeirauniverso.com',
    },
    somma: {
        name: 'SOMMA',
        primaryColorName: 'somma-primary-',
        secundaryColorName: 'somma-secondary-',
        primaryColorHex: {
            one: "#0675A2",
            two: "#0675A2",
            three: "#086184",
            four: "#095472",
            five: "#0A445C",
            six: "#0A445C",
        },
        secundaryColorHex: {
            one: "#14EDD9",
            two: "#14EDD9",
            three: "#14EDD9",
            four: "#14EDD9",
            five: "#14EDD9",
            six: "#14EDD9",
        },
        ilustra: {
            primary: "#14EDD9",
            secundary: "#095472"
        },
        urls: {
            CLIENT: process.env.VUE_APP_ROOT_CLIENT_SOMMA,
            MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE_SOMMA,
            FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION_SOMMA
        },
        contact: {
            email: 'suporte.fidc@gruposomma.com.br',
            tel: '48 3037 1018',
        },
        favicon: '/somma-favicon.svg',
        email: 'suporte.fidc@gruposomma.com.br',
    },
}

export const FILTERS = {
    withECPF: null,
    totalValue: {
        minValue: null,
        maxValue: null,
    }
}

export const FILTER_ITEMS = {
    ECPF: [
        { label: 'Sim', value: 'true' },
        { label: 'Não', value: 'false' },
    ],
}

export const ACCESS_LEVEL = {
    ADMIN: 0,
    OPERATIONAL: 1,
}